import React, { useMemo } from 'react';
import IndicatorTip from './IndicatorTip';
import MonitorChart from './MonitorChart';
import { DEFAULT_TEXT, INDICATOR_TITLE } from '../config';
import styles from '../index.less';

const IndicatorCard = ({
  type = 'online',
  indicatorInfo: { dataCurves, level = 0, time, poorLineNum = 0 },
  error,
  isOffline,
  sn,
}) => {
  const isError = useMemo(() => !dataCurves || error, [error, dataCurves]);

  return (
    <div className={styles['indicator-card']}>
      <h1 className={styles['indicator-header-title']}>
        <span>{INDICATOR_TITLE[type]}</span>
        <span className={styles['indicator-header-utime']}>{time || DEFAULT_TEXT}&nbsp;更新</span>
      </h1>
      <MonitorChart type={type} dataCurves={dataCurves} isOffline={isOffline} isError={isError} />
      {!isError && level !== 0 && <IndicatorTip level={level} type={type} sn={sn} />}
      {!isError && poorLineNum > 0 && (
        <IndicatorTip level={1} type={type} sn={sn} poorLineNum={poorLineNum} />
      )}
    </div>
  );
};

export default IndicatorCard;
